<template>
    <div class="flex items-center gap-1">
        <redesign-tag
            :color="statusTag.color"
            :background-color="statusTag.backgroundColor"
            :tag-content="statusTag.tagContent"
            :icon-size="dynamicSizes.iconSize"
            :text-size="dynamicSizes.textSize"
            :uppercase="false"
        >
            <template
                v-if="extraCallStatusData"
                #extra-content
            >
                <div class="call-icon">
                    <redesign-tag
                        :color="extraCallStatusData.color"
                        :background-color="'white'"
                        :tag-content="extraCallStatusData.tagContent"
                        :icon-size="dynamicSizes.iconSize"
                        :text-size="dynamicSizes.textSize"
                        :uppercase="false"
                    />
                </div>
            </template>
        </redesign-tag>

        <RedesignWrapupCountdown
            :extension="extension"
            :text-size="textSize"
        />
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ExtensionStatusData } from '@/composables/useExtensionStatus'
import RedesignTag from '@/components/RedesignBaseComponents/RedesignTag.vue'
import RedesignWrapupCountdown from '@/components/RedesignComponents/RedesignTableComponents/RedesignWrapupCountdown.vue'
import type { Extension } from '@/types/extension'

const props = defineProps<{
    extensionStatusData: ExtensionStatusData
    textSize: string
    extension?: Extension
}>()

const statusTag = computed(() => {
    const color = props.extensionStatusData?.color ?? ''

    return {
        color: 'white', // For transparency use `color`
        backgroundColor: color, // For transparency use `${color}19`
        tagContent: [
            {
                iconName: props.extensionStatusData?.iconName,
                text: props.extensionStatusData?.text
            }
        ]
    }
})

const dynamicSizes = computed(() => ({
    textSize: props.textSize,
    iconSize: parseInt(props.textSize)
}))

const extraCallStatusData = computed(() => {
    return props.extensionStatusData.extraCallStatusData ? {
        color: props.extensionStatusData?.extraCallStatusData?.color,
        tagContent: [
            {
                iconName: props.extensionStatusData.extraCallStatusData?.iconName,
                text: ''
            }
        ]
    }: null
})
</script>

<style lang="scss" scoped>
.call-icon {
    @apply mx-0.5;
    animation: zoom-pulse 1s ease-in-out infinite;
}

@keyframes zoom-pulse {
    0% {
        transform: scale(0.8);
    }
    50% {
        transform: scale(1);
    }
    100% {
        transform: scale(0.8);
    }
}
</style>
